<template>
  <div style="height: 100vh">
    <div class="app" :style="bgStyle">
      <div class="team">
        <div class="text-a">截止{{ dayjs().year() }}年{{ dayjs().month() + 1 }}月{{ dayjs().date() }}日，小當家业绩累计
          <div>完成： <u class="text-b" >{{ nowYearFinish }}</u> 量</div>
        </div>
        <div class="text-c" v-if="!inMiniProgram">
          今日股价：{{ (nowYearFinish / 1709).toFixed(3) }}元/股 (目标股价：{{nowStockPrice}}元/股)
        </div>
        <div class="text-c" v-else>
          今日席位参考系数：{{ (nowYearFinish / 1709).toFixed(3) }}（目标系数：{{ nowStockPrice }}）
        </div>
      </div>
      <div class="eCharts" ref="eCharts">

      </div>
    </div>
  </div>


</template>

<script setup>
import dayjs from "dayjs";
import {getAll, getYearDateToInvest} from "@/api/statistics";
import {onMounted, ref} from "vue";
import {isMiniProgram} from "@/utils/env";
import bgWeb from "@/assets/investBg-m.png";
import bgMiniProgram from "@/assets/investBg-m-mp.png";

// 小程序端不展示「股价 / 元每股 / 估值」等表述（金融类目风险），
// 页面指标行与图表 x 轴都换成中性的"席位系数"，背景图也换成去除了这些字样的专用版本。
// 判定与切换逻辑见 src/utils/env.js
const inMiniProgram = isMiniProgram();
const bgStyle = {backgroundImage: `url(${inMiniProgram ? bgMiniProgram : bgWeb})`};

import * as echarts from 'echarts/core';
import {
  DatasetComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import {BarChart} from 'echarts/charts';
import {CanvasRenderer} from 'echarts/renderers';

echarts.use([
  DatasetComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  CanvasRenderer
]);
// let yearData = ref({
//   oneOrderCountYear: ''
// })
// const getAllofYear = () => {
//   const month = dayjs().format("YYYY-MM")
//   getAll(month).then(res => {
//     if (res.code === '0') {
//       yearData.value = res.data
//     } else {
//       ElMessage({
//         type: "error",
//         message: "异常"
//       })
//     }
//   })
// }

let nowYearTarget = ref()
let nowYearFinish = ref()
let nowStockPrice = ref()
let investData = ref({})

/**
 * 图表 x 轴标签由后端拼好返回，形如 "2024\n\n股价:\n1.745元/股"。
 * 小程序端要把「股价」「元/股」这类金融表述去掉，只留「2024\n\n1.745」。
 * 取第一个四位数当年份、最后一个数字当数值 —— 后端中间那行改字也不影响。
 */
const toPlainAxisLabel = (raw) => {
  const text = String(raw ?? '')
  const year = (text.match(/\d{4}/) || [])[0]
  const nums = text.match(/\d+(?:\.\d+)?/g) || []
  const value = nums.length > 1 ? nums[nums.length - 1] : ''
  return year && value ? `${year}\n\n${value}` : text.trim()
}

const getInvestDate = () => {
  getYearDateToInvest().then(res => {
    if (res.code === '0') {
      const history = res.data.history || []
      // 浏览器端保留后端原文（甲方内部要看股价）；小程序端裁成纯数值
      investData.value = inMiniProgram
        ? history.map((row) => [toPlainAxisLabel(row[0]), row[1], row[2]])
        : history
      nowYearTarget.value = history[history.length - 1][1]
      nowYearFinish.value = history[history.length - 1][2]
      nowStockPrice.value = res.data.targetPrice
    } else {

    }
  })
}


const eCharts = ref();
let myChart;
const loadingECharts = () => {
  myChart = echarts.init(eCharts.value);
  myChart.setOption({
    color: ['#5cb6b6', '#ed6801'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      top: '5%',
      left: 'center',
      textStyle: { //图例文字的样式
        fontSize: 15
      },
    },
    dataset: {
      source: [
        ['product', '目标', '完成'],
        ...investData.value,
      ]
    },
    xAxis: {type: 'category',
      axisLabel: {
        inside: false,
        textStyle: {
          color: '#000',
          fontSize:'10',
          itemSize:'',
          fontWeight: 'bold'
        }
      },
    },
    yAxis: {type: 'value'},
    grid: {
      left: 45
    },
    series: [{
      name:'目标',
      type: 'bar',
      barGap: '5%',
      label: {
        show: true, //开启显示
        position: 'top', //在上方显示
        textStyle: { //数值样式
          color: 'black',//字体颜色
          fontSize: 10//字体大小
        }
      }
    }, {
      name:'完成',
      type: 'bar',
      label: {
        show: true, //开启显示
        position: 'top', //在上方显示
        textStyle: { //数值样式
          color: 'black',//字体颜色
          fontSize: 10//字体大小
        }
      }
    }]
  })
}

onMounted(() => {

  getInvestDate()
  setTimeout(() => {
    loadingECharts();
  }, 1300)
})
</script>

<style>
.app {
  margin-top: -11px;
  width: 100%;
  height: 100%;
  position: relative;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.team {
  position: absolute;
  /*background: linear-gradient(#f6d4ae, #f3c04a);*/
  background-color: white;
  border-radius: 50px;
  left: 5%;
  top: 20%;
  width: 85%;
  text-align: center;
  padding: 10px;
}

.eCharts {
  position: absolute;
  background-color: white;
  /*border-radius: 100px;*/
  top: 48%;
  width: 70%;
  height: 30%;
  /*padding: 10px;*/
}

.text-a {
  font-size: 1.15rem;
  font-weight: bold;
}

.text-b {
  color: #ad0f13;
}

.text-c {
  font-size: 0.9rem;
  font-weight: bold;
  color: #df3c3e;
}

.text-d {
  color: #e30114;
}

/** {*/
/*  margin: 0;*/
/*  padding: 0;*/
/*}*/
</style>
